import { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ReactDatePicker = ({ label, placeholder, minDate, dateState }) => {
    const datePickerRef = useRef(null);
    const now = new Date();

    return (
        <div className="calender-date-wrapper">
            {label && <label className="date-label">{label}</label>}

            <DatePicker
                ref={datePickerRef}
                selected={dateState.selectedDate}
                onChange={(date) => dateState.setSelectedDate(date)}
                popperPlacement="top-end"
                placeholderText={placeholder}
                minDate={now}
                maxDate={minDate}
                onKeyDown={(e) => e.preventDefault()}
                showTimeSelect
                filterTime={(time) => time.getTime() > now.getTime()}
                fixedHeight
                timeFormat="HH:mm"
                timeIntervals={1}
                timeCaption="time"
                dateFormat="MMMM d, yyyy h:mm aa"
            />
        </div>
    );
};

export default ReactDatePicker;
